import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import { servicesIndexJsonLd } from "@/lib/structured-data";

export const Route = createFileRoute("/services/")({
  head: () => {
    const base = seo({
      title: "Services",
      description:
        "Spray foam, blown, and batting insulation plus roofing in Northwest Wisconsin. Gary matches the product to the building and budget.",
      path: "/services",
    });
    return {
      ...base,
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(servicesIndexJsonLd()),
        },
      ],
    };
  },
});
